import { render } from "preact";
import { App } from "./App";
import "./styles/index.css";
import { watchSystemTheme } from "./theme";

const root = document.getElementById("app");
if (!root) throw new Error("missing #app root");
watchSystemTheme();
render(<App />, root);
